import { useEffect, useState } from "react";
import { scrollElementTo } from "../utils/scrollToFooter";

/** Track frame scroll for Return to Top. Native wheel stays intact; CSS overscroll-behavior contains the page. */
export function useContainedScroll(ref) {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;

    function onScroll() {
      setShowTop(el.scrollTop > 80);
    }

    el.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => el.removeEventListener("scroll", onScroll);
  }, [ref]);

  function returnToTop() {
    scrollElementTo(ref.current, 0);
  }

  return { showTop, returnToTop };
}
